// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Accounting close workflow route.
 *
 * Provides a step-by-step wizard for the month-end accounting close process.
 */
import { AccountingCloseWizard } from '@/accounting/components/accounting-close-wizard';
import { PageContent } from '@/components/page-content';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/accounting/close-workflow')({
  component: AccountingCloseRoute,
});

function AccountingCloseRoute() {
  return (
    <PageContent
      sx={{
        gap: 3,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '100%',
      }}
    >
      <AccountingCloseWizard />
    </PageContent>
  );
}
